
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Skeleton } from '@mui/material';
const TableLoader = ({ rows }: { rows: number }) => {
    return (
        <Box sx={{ width: "100%", marginTop: 1 }}>
            <Box sx={{ display: "flex", m: 3, gap: 1, justifyContent: "flex-end", alignItems: "center" }}>
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton variant="rectangular" width={120} height={30} sx={{ borderRadius: 5 }} />
            </Box >
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {[...Array(rows)]?.map((_, index) => (
                                <TableCell key={`head_cell_${index}`}>
                                    <Skeleton variant="text" />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.from(new Array(3)).map((_, index) => (
                            <TableRow key={index}>
                                {[...Array(rows)]?.map((_, index) => (
                                    <TableCell key={`cell_${index}`}>
                                        <Skeleton variant="text" />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>

    )
}
export default TableLoader;